import { useState, FormEvent, ChangeEvent } from "react";
import emailjs from "emailjs-com";

export default function Newsletter() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [adults, setAdults] = useState("");
  const [children, setChildren] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSend = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      fullName === "" ||
      email === "" ||
      phone === "" ||
      adults === "" ||
      checkInDate === "" ||
      checkOutDate === ""
    ) {
      setErrMsg("All fields are required!");
      return;
    }

    const messageContent = `
      Full Name: ${fullName}
      Email: ${email}
      Phone: ${phone}
      Number of Adults: ${adults}
      Number of Children: ${children}
      Check-in Date: ${checkInDate}
      Check-out Date: ${checkOutDate}
    `;

    const templateParams = {
      from_name: fullName,
      reply_to: email,
      message: messageContent,
    };

    emailjs.send(
      'service_bxzsb9j', // Your EmailJS service ID
      'template_dldmfrk', // Your EmailJS template ID
      templateParams,
      'Jf_YeMy_PzdKxQY7V' // Your EmailJS user ID
    )
      .then((result) => {
        console.log("Email sent successfully:", result.text);
        setSuccessMsg("Your booking request has been sent successfully!");
        setErrMsg("");
        setFullName("");
        setEmail("");
        setPhone("");
        setAdults("");
        setChildren("");
        setCheckInDate("");
        setCheckOutDate("");
      }, (error) => {
        console.error("Error sending email:", error.text);
        setErrMsg("Error sending message. Please try again later.");
      });
  };

  return (
    <>
      <style>{`
        .rounded-input {
          border-radius: 25px;
          border: 1px solid #ced4da;
          padding: 10px 20px;
          margin-bottom: 15px;
          width: 100%;
          background-color: #f8f9fa;
        }
        .submit-btn {
          border-radius: 25px;
          padding: 10px 20px;
          background-color: #007bff;
          color: #fff;
          border: none;
          cursor: pointer;
        }
        .submit-btn:hover {
          background-color: #0056b3;
        }
      `}</style>
      <div className="container newsletter mt-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="row justify-content-center">
          <div className="col-lg-10 border rounded p-1">
            <div className="border rounded text-center p-1">
              <div className="bg-white rounded text-center p-5">
                <h4 className="mb-4">
                  B O O K <span className="text-primary text-uppercase">N O W</span>
                </h4>
                {errMsg && (
                  <p className="text-danger">{errMsg}</p>
                )}
                {successMsg && (
                  <p className="text-success">{successMsg}</p>
                )}
                <form onSubmit={handleSend}>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="text"
                      placeholder="Enter your full name"
                      value={fullName}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setFullName(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="tel"
                      placeholder="Enter your phone number"
                      value={phone}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="number"
                      placeholder="Number of adults"
                      value={adults}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setAdults(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="number"
                      placeholder="Number of children"
                      value={children}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setChildren(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="date"
                      placeholder="Check-in Date"
                      value={checkInDate}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setCheckInDate(e.target.value)}
                    />
                  </div>
                  <div className="position-relative mx-auto" style={{ maxWidth: "400px" }}>
                    <input
                      className="form-control rounded-input"
                      type="date"
                      placeholder="Check-out Date"
                      value={checkOutDate}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setCheckOutDate(e.target.value)}
                    />
                  </div>
                  <button className="submit-btn" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
